/**
 * Ícone do módulo, para o card de prévia do painel de artefato (Fase 1 —
 * fundação, plano `moonlit-conjuring-sun`).
 *
 * O `UI_REGISTRY` não carrega ícone/cor por entrada — só `module` como chave
 * de string (`crm/confirmacao`, `bi/type`, ...). Este util faz o join
 * `moduleKey → ícone` com as fontes que JÁ existem por módulo, sem precisar
 * de um catálogo de ícones próprio para a IA (que divergiria do menu da
 * plataforma no primeiro módulo que trocasse o dele).
 *
 * Duas fontes, nessa ordem:
 * 1. `GESTAO_GROUPS`/`CLIENTE_GROUPS` (`navigation-modules.js`) — o esqueleto
 *    já achatado que a sidebar da plataforma usa, chaveado pela `key` de
 *    módulo (`crm`, `bi`, `financeiro`, `tarefas`, `partnership`, ...).
 * 2. `ROUTE_DEFS` (`navigation-routes.js`) — chaveado por `ROUTE_KEYS`, cujos
 *    valores TAMBÉM são strings de moduleKey (`task`, `fee-fixo`, `carteira`,
 *    ...) e cobrem módulos que não aparecem achatados na sidebar.
 *
 * Módulo sem ícone mapeado em nenhuma das duas cai no fallback genérico
 * (`grid-six` — mesmo ícone já usado como "Ferramentas"/módulo genérico em
 * `navegacao-v2/constants/partes.js` e nas telas de asset-allocation).
 *
 * Função PURA: sem leitura de store, sem `this`, sem I/O — só dados estáticos
 * dos dois catálogos.
 *
 * Sem `?.`/`??` (o Babel deste projeto não transpila). Acentos UTF-8 reais.
 */
import { GESTAO_GROUPS, CLIENTE_GROUPS } from '@modules/navegacao-v2/constants/navigation-modules'
import { ROUTE_DEFS } from '@constants/navigation-routes'

// Ícone neutro para módulo sem entrada em nenhum catálogo — nunca undefined/vazio.
export const ICONE_MODULO_FALLBACK = 'grid-six'

function achatarGrupos(grupos) {
  const itens = []
  ;(grupos || []).forEach((grupo) => {
    ;(grupo.items || []).forEach((item) => itens.push(item))
  })
  return itens
}

// Mapa `moduleKey → icon`, construído uma vez a partir do esqueleto ESTÁTICO
// da navegação (nenhum dos dois catálogos depende de `$access`/sessão).
function construirMapaDeIcones() {
  const mapa = {}

  achatarGrupos(GESTAO_GROUPS)
    .concat(achatarGrupos(CLIENTE_GROUPS))
    .forEach((item) => {
      if (item && item.key && item.icon && !mapa[item.key]) {
        mapa[item.key] = item.icon
      }
    })

  Object.keys(ROUTE_DEFS).forEach((chave) => {
    const def = ROUTE_DEFS[chave]
    if (def && def.icon && !mapa[chave]) {
      mapa[chave] = def.icon
    }
  })

  return mapa
}

let mapaDeIconesCache = null

function mapaDeIcones() {
  if (!mapaDeIconesCache) mapaDeIconesCache = construirMapaDeIcones()
  return mapaDeIconesCache
}

/**
 * Resolve o ícone do módulo (segmento antes da `/` em `ui.component`, ex.:
 * `crm` de `crm/confirmacao`) para o card de prévia do artefato.
 *
 * @param {string} moduleKey
 * @returns {string} nome de `icon-svg` — nunca vazio/undefined.
 */
export function resolverIconeDoModulo(moduleKey) {
  if (!moduleKey) return ICONE_MODULO_FALLBACK
  const icone = mapaDeIcones()[moduleKey]
  return icone || ICONE_MODULO_FALLBACK
}
